import { setupIconFont } from '@tw/tw-components-rn';

setupIconFont(require('@/app/assets/fonts/iconfont.json'));
